import { OrganizationDTO, OrganizationRequestDTO } from '@/models';
import { axiosBase } from './axios-base';

export const fetchOrganizations = (): Promise<{ data: OrganizationDTO[] }> => {
  return axiosBase.get('/api/organizations');
};
